import ProductService from '@/services/ProductService.js'

export const state = {
  suppliers: [],
  supplier: {}
}

export const mutations = {
  ADD_SUPPLIER(state, supplier) {
    state.suppliers.push(supplier)
  },
  DELETE_SUPPLIER(state, supplier) {
    state.suppliers = state.suppliers.filter(t => t.id != supplier.id)
  },
  SET_SUPPLIERS(state, suppliers) {
    state.suppliers = suppliers
  },
  SET_SUPPLIER(state, supplier) {
    state.supplier = supplier
  },
  EDIT_SUPPLIER(state, supplier) {
    state.supplier = supplier
  }
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
  createSupplier({ commit, dispatch }, supplier) {
    return ProductService.postSupplier(supplier)
      .then(response => {
        commit('ADD_SUPPLIER', supplier)
        const notification = {
          type: 'success',
          message: 'Your new supplier has been created!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem creating new supplier: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchSuppliers({ commit, dispatch }) {
    ProductService.getSuppliers()
      .then(response => {
        commit('SET_SUPPLIERS', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching suppliers: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  fetchSupplier({ commit, getters }, id) {
    var supplier = getters.getSupplierById(id)

    if (supplier) {
      commit('SET_SUPPLIER', supplier)
      return supplier
    } else {
      return ProductService.getSupplier(id) // <-- Send the prop id to our ProductService//
        .then(response => {
          commit('SET_SUPPLIER', response.data)
          return response.data
        })
    }
  },
  async removeSupplier({ commit }, supplier) {
    await ProductService.deleteSupplier(supplier)
    commit('DELETE_SUPPLIER', supplier)
  },
  editSupplier({ commit }, supplier) {
    ProductService.editSupplier(supplier)
    commit('EDIT_SUPPLIER', supplier)
  }
}

export const getters = {
  getSupplierById: state => id => {
    return state.suppliers.find(supplier => supplier.id === id)
  }
}
